
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content",
      function () {
        return require("private-next-pages/content/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content"])
      });
    }
  